import * as types from '../mutation-types'

// namespaced
export const namespaced = true

// state
export const state = {
  guest_contact: {
    name: null,
    phone: null
  }
}

// getters
export const getters = {
  guest_contact: state => state.guest_contact,
  has_guest_contact: state => !!(state.guest_contact.name && state.guest_contact.phone)
}

// mutations
export const mutations = {
  [types.RESET_TAKEAWAY_CONTACT] (state) {
    state.guest_contact = {
      name: null,
      phone: null
    }
  },

  [types.SET_TAKEAWAY_CONTACT] (state, payload) {
    state.guest_contact = {
      name: payload.name ? payload.name : null,
      phone: payload.phone ? payload.phone : null
    }
    console.log('state.guest_contact')
    console.log(state.guest_contact)
  }
}

// actions
export const actions = {

  resetContact ({ commit }) {
    commit(types.RESET_TAKEAWAY_CONTACT)
  },

  setContact ({ commit, state }, payload) {
    console.log('setContactsetContactsetContactsetContactsetContactsetContact')
    if (!payload) {
      commit(types.RESET_TAKEAWAY_CONTACT)
    } else {
      commit(types.SET_TAKEAWAY_CONTACT, {
        name: payload.name,
        phone: payload.phone
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/takeaway.js